import { render, staticRenderFns } from "./ugc-item.vue?vue&type=template&id=6f5db3b7&scoped=true&"
import script from "./ugc-item.vue?vue&type=script&lang=js&"
export * from "./ugc-item.vue?vue&type=script&lang=js&"
import style0 from "./ugc-item.vue?vue&type=style&index=0&id=6f5db3b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5db3b7",
  null
  
)

export default component.exports